/* eslint-disable max-len */
import * as React from 'react';
import { ScrollToTopOnMount } from '../scrolltotop';

export const PrivacyAndCookies = () => (
  <>
    <ScrollToTopOnMount />
    <div className={'content_page'}>
      <h1>Privacy & Cookies</h1>
      <div className={'text_block'}>
        <p>
            Omdat de regelgeving omtrent internet in de EU opgesteld is door een stel mensen die denken dat je een krijtje gebruikt om een tablet te bedienen, zijn we verplicht om hier een aantal vanzelfsprekende dingen verder uit te leggen. Deze privacyverklaring is van toepassing op alle websites en apps van DT Media B.V. (wij). Wij zijn de verwerkingsverantwoordelijke voor de gegevensverwerking. Als functionaris voor gegevensbescherming hebben wij Marc Cox aangewezen (<a href="mailto:privacy@dumpert.nl" target="_blank" rel="noopener noreferrer">
          privacy@dumpert.nl
          </a>).
        </p>
      </div>
      <div className={'text_block'} data-columns="2">
        <h3>Privacy</h3>
        <p>
          Wij gaan zorgvuldig om met je geregistreerde gegevens, zoals
          e-mail en nickname. Registreren is bedoeld om reacties te geven op
          de site, om Premium lid te worden of om indien nodig contact met
          je op te kunnen nemen over door jou ingestuurde of ge&uuml;ploade
          content. De verwerking is noodzakelijk om je deze diensten te
          kunnen leveren. Ook als je een ban hebt gekregen registreren wij
          dit, inclusief de reden van de ban. Hiervoor hebben wij een
          gerechtvaardigd belang, namelijk om ongewenste praktijken op onze
          sites en apps te voorkomen.
        </p>

        <p>
          Wij verkopen geen e-mail of andere gegevens. Mochten we in de
          toekomst toch besluiten stijlloze aanbiedingen te versturen, dan
          is dit uiteraard opt-in en zullen we dit ruimschoots van tevoren
          duidelijk maken. In sommige gevallen zijn wij verplicht bepaalde
          gegevens van jou te verstrekken, bijvoorbeeld aan de politie in
          het kader van een opsporingsonderzoek of aan een derde als de
          inhoud van een door jou geplaatste uiting op een van onze websites
          of apps onrechtmatig is tegenover die derde. We zullen dan
          uitsluitend gegevens verstrekken als duidelijk is dat we hiertoe
          wettelijk verplicht zijn.
        </p>

        <h3>Cookies</h3>
        <p>
          Wij plaatsen cookies en gebruiken soortgelijke technieken die
          noodzakelijk zijn voor het functioneren van de site. Via deze
          cookies verwerken wij je IP-adres, device ID en de tijdstippen
          waarop je in- en uitlogt. Dit doen wij ten behoeve van logging, AB
          testen en overige technische functionaliteiten, om spammers en
          trollen tegen te gaan en voor debugging. Wij doen dit op basis van
          toestemming, die je geeft door de cookieverklaring van de website
          of app die je bezoekt te accepteren.
        </p>

        <p>
          Zogenaamde 'tracking cookies' worden niet door ons geplaatst, maar
          door derde partijen, zoals voor analytische doeleinden of
          advertenties. De privacy verklaringen van deze derden zijn in dat
          geval van toepassing. Om deze reden kunnen wij hier geen
          verantwoording voor nemen.
        </p>

        <p>
            Meer informatie over cookies en soortgelijke technieken en het gebruik daarvan door ons en derden via onze website en apps vind je <a href="https://tmgonlinemedia.nl/cookies/dumpert.nl" target="_blank" rel="noopener noreferrer">
            hier
          </a>.
        </p>

        <h3>Bewaartermijn</h3>
        <p>
          We bewaren je gegevens zolang nodig is voor de hierboven genoemde
          doeleinden of om te voldoen aan wettelijke verplichtingen.
          Inloggegevens verwijderen we in principe als je je account opheft,
          tenzij het nodig is om ze langer te bewaren, bijvoorbeeld omdat je
          een ban hebt.
        </p>

        <h3>Jouw rechten</h3>
        <p>
            Wil je je gegevens inzien, corrigeren of verwijderen, ons gebruik daarvan beperken, bezwaar maken tegen ons gebruik van jouw gegevens of je gegevens ontvangen of laten overzetten naar een andere partij? Neem dan contact op via <a href="mailto:privacy@dumpert.nl" target="_blank" rel="noopener noreferrer">
            privacy@dumpert.nl
          </a>. Intrekken van toestemming doe je eenvoudig door je cookies te verwijderen. Lees hierover meer in onze <a href="https://tmgonlinemedia.nl/cookies/dumpert.nl" target="_blank" rel="noopener noreferrer">
            cookieverklaring
          </a>.
        </p>

        <p>
            Klachten kun je indienen bij de <a href="https://autoriteitpersoonsgegevens.nl/nl/zelf-doen/privacyrechten/klacht-over-gebruik-persoonsgegevens" target="_blank" rel="noopener noreferrer">
            Autoriteit Persoonsgegevens
          </a>.
        </p>

        <h3>Tot slot</h3>
        <p>
          Wij kunnen te allen tijde wijzigingen aanbrengen in deze
          privacyverklaring. Elke aanpassing zal op deze pagina worden
          gepubliceerd.
        </p>
      </div>    
    </div>
  </>
);
